import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { initializeGTMWithEvent } from '../../utils/googleTagManager';
import { eventGA } from '../../utils/googleAnalytics';

const propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  children: PropTypes.node,
  type: PropTypes.oneOf(['button', 'link']),
  buttonType: PropTypes.string,
  value: PropTypes.number,
  gaAction: PropTypes.string,
};

const defaultProps = {
  children: null,
  type: 'button',
  buttonType: 'button',
  value: 1,
  gaAction: null,
};

const TrackedButton = ({ title, action, children, type, buttonType, value, gaAction, ...rest }) => {
  const label = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`;
  const eventAction = gaAction || `Click on "${title}" button`;
  const onClick = (e) => {
    initializeGTMWithEvent({
      event: 'buttonclick',
      buttondata: {
        action,
        title,
      },
    });

    eventGA({
      category: 'engagement',
      action: eventAction,
      label,
      value,
    });

    if (rest.onClick) {
      rest.onClick(e);
    }
  };
  const content = children || title;
  return type === 'button' ? (
    <button type={buttonType} {...rest} onClick={onClick}>{content}</button>
  ) : (
    <Link {...rest} onClick={onClick}>{content}</Link>
  );
};

TrackedButton.propTypes = propTypes;
TrackedButton.defaultProps = defaultProps;

export default TrackedButton;
